import { useContext } from 'react';
import { DialogContext } from '@/components/features/dialogs/infra/context/DialogContext';
import { CameraButton } from '@/components/features/ImageUploadButton';
import Avatar from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import Icon, { IconName } from '@/components/ui/Icon';
import { cn } from '@/lib/utils';

interface ProfilePhotoUploaderProps {
  photoUrl: string | null;
  size: number;
  onUploadComplete?: (url: string) => void;
  onError?: (error: Error) => void;
  layout?: 'side' | 'hover';
}

export function ProfilePhotoUploader({
  photoUrl,
  size,
  onUploadComplete,
  onError,
  layout = 'hover',
}: ProfilePhotoUploaderProps) {
  const { openDialog } = useContext(DialogContext);
  const BORDER_WIDTH = size > 100 ? 6 : 3;
  const onClick = () => {
    openDialog('photo-upload', {
      onUploadComplete,
      onError,
    });
  };
  return (
    <div
      className='relative cursor-pointer'
      style={{
        width: size + BORDER_WIDTH * 2,
        height: size + BORDER_WIDTH * 2,
      }}
      onClick={onClick}
    >
      {photoUrl || layout === 'side' ? (
        <Avatar
          className={cn(
            'border-white-400 bg-white-200 mb-2 h-fit w-fit border-[6px]',
            size > 100 ? 'border-[6px]' : 'border-[3px]'
          )}
          style={{
            width: size + BORDER_WIDTH * 2,
            height: size + BORDER_WIDTH * 2,
          }}
          imageUrl={photoUrl || undefined}
        />
      ) : null}
      {layout === 'hover' ? (
        <CameraButton
          size={size}
          className={cn(
            'absolute top-0 left-0 transition-opacity',
            size > 100 ? 'm-[6px]' : 'm-[3px]',
            photoUrl && 'opacity-0'
          )}
        />
      ) : (
        <Button
          variant='ghost'
          style={size ? { width: size / 3, height: size / 3 } : undefined}
          className='bg-white-300 absolute bottom-0 left-0 rounded-full p-0 shadow'
        >
          <Icon variant={IconName.Camera} width={16} height={16} />
        </Button>
      )}
    </div>
  );
}
